/* eslint-disable react/jsx-props-no-spreading */
/* istanbul ignore file */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import { SlickCarouselLargeNew } from './SlickCarouselLargeNew/SlickCarouselLargeNew';
import SlickCarouselSmall from './SlickCarousalSmall/SlickCarouselSmall';
import formattedFilmStripData from '../../helpers/FormatImagesAndVideos';

const SlickCarouselWrapper = ({
    productImagesAndVideos,
    slideCallback,
    dataAutomationId,
    deviceType,
    isCarouselTabDisplay,
    enableVideoPlacementChange,
    ppId,
    preferences: { videoPlacementPosition = 3 } = {},
    carouselTheme,
    carouselItemRenderer,
    rewindOnChange,
    isPDPImage,
    isMobilePDPImageZoomed,
    urgencyMessagingEnabled,
    enableZoomOnProductImage,
}) => {
    const key = 'productImageCarouselWrapper';
    const { isDesktop, isTablet } = deviceType;
    const containerRef = useRef(null);
    let renderCarousel = '';

    // Define common props that both Large and Small components will use
    const commonProps = {
        carouselData: enableVideoPlacementChange
            ? formattedFilmStripData(videoPlacementPosition, productImagesAndVideos)
            : productImagesAndVideos,
        carouselItemRenderer,
        themeConfig: carouselTheme,
        automationId: dataAutomationId,
        slideCallback,
        rewindOnChange,
        enableVideoPlacementChange,
        deviceType,
        urgencyMessagingEnabled,
        enableZoomOnProductImage,
    };

    renderCarousel = isDesktop ? (
        <ErrorBoundary>
            <SlickCarouselLargeNew
                {...commonProps} // Spread common props
                swipeOptions={{ continuous: false }}
                key={key}
            />
        </ErrorBoundary>
    ) : (
        (renderCarousel = (
            <ErrorBoundary>
                <SlickCarouselSmall
                    ref={containerRef}
                    {...commonProps} // Spread common props
                    isCarouselTabDisplay={isCarouselTabDisplay}
                    displayArrows={isTablet}
                    repeat={false}
                    isPDPImage={isPDPImage}
                    key={key}
                    ppId={ppId}
                    isMobilePDPImageZoomed={isMobilePDPImageZoomed}
                />
            </ErrorBoundary>
        ))
    );

    return renderCarousel;
};

SlickCarouselWrapper.propTypes = {
    productImagesAndVideos: PropTypes.array.isRequired,
    slideCallback: PropTypes.func,
    dataAutomationId: PropTypes.string.isRequired,
    deviceType: PropTypes.object.isRequired,
    isCarouselTabDisplay: PropTypes.bool,
    enableZoomOnProductImage: PropTypes.bool.isRequired,
    isMobilePDPImageZoomed: PropTypes.bool,
    urgencyMessagingEnabled: PropTypes.bool,
    enableVideoPlacementChange: PropTypes.bool,
    ppId: PropTypes.string,
    preferences: PropTypes.shape({
        videoPlacementPosition: PropTypes.number,
    }),
    carouselTheme: PropTypes.object.isRequired,
};

export default SlickCarouselWrapper;
